import React, {useState} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Check, Loader, Share } from "lucide-react";
import PhoneNumberInput from "./PhoneNumberInput.tsx";
import {toast} from "react-toastify";

interface ShareFormValues {
    phoneNumber: string;
    firstName: string;
    lastName: string;
}

interface TicketShareFormProps {
    onSubmit: (values: ShareFormValues, formik: any) => void;
    response: string;
    requestStatus: string;
}

const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
        .required("Le numero de téléphone est requis.")
        .matches(/^\+?[0-9]{7,15}$/, "Le numéro de téléphone doit être valide."),
    firstName: Yup.string(),
    /*    .required("Le prénom est requis.")
        .min(2, "Trop court"),*/
    lastName: Yup.string(),
        /*.required("Le nom est requis.")
        .min(2, "Trop court"),*/
});

const TicketShareForm: React.FC<TicketShareFormProps> = ({
                                                             onSubmit,
                                                             response,
                                                             requestStatus,
                                                         }) => {
    const [isPhoneValid, setIsPhoneValid] = useState(false);

    const handleValidPhone = (fullNumber: string) => {
        formik.setFieldValue('phoneNumber', fullNumber);
    };

    const formik = useFormik<ShareFormValues>({
        initialValues: {
            phoneNumber: "",
            firstName: "",
            lastName: "",
        },
        validationSchema,
        onSubmit: (values) => {
            if(isPhoneValid) {
                onSubmit(values, formik);
            } else {
                toast.error('Wow so easy !');
            }
            //   resetForm();
        },
    });

    return (
        <form
            onSubmit={formik.handleSubmit}
            className="w-full max-w-md mx-auto p-6 space-y-6"
        >
            <h2 className="text-2xl font-semibold text-center text-gray-800">
                Partager le ticket
            </h2>

            {/* Phone Number */}
            <div>
                <label className="block text-sm font-medium text-gray-700">
                    Numero de téléphone
                </label>
                <PhoneNumberInput
                    setIsPhoneValid={setIsPhoneValid}
                    onValidPhone={handleValidPhone}
                    autoSet={false}
                    required={true}
                />
              {/*  <input
                    type="tel"
                    name="phoneNumber"
                    className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#9EBE43]"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.phoneNumber}
                />*/}
                {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                    <p className="text-red-500 text-sm mt-1">
                        {formik.errors.phoneNumber}
                    </p>
                )}
            </div>

            {/* First Name */}
            <div>
                <label className="block text-sm font-medium text-gray-700">Nom</label>
                <input
                    type="text"
                    name="lastName"
                    className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#9EBE43]"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName && (
                    <p className="text-red-500 text-sm mt-1">{formik.errors.lastName}</p>
                )}
            </div>

            {/* Last Name */}
            <div>
                <label className="block text-sm font-medium text-gray-700">
                    Prénom
                </label>
                <input
                    type="text"
                    name="firstName"
                    className="mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#9EBE43]"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName && (
                    <p className="text-red-500 text-sm mt-1">{formik.errors.firstName}</p>
                )}
            </div>

            <button
                type="submit"
                disabled={
                    formik.isSubmitting ||
                    requestStatus == "201" ||
                    requestStatus == "400"
                }
                className="w-full flex items-center justify-center bg-[#9EBE43] text-white font-semibold py-3 px-4 rounded-md transition duration-300"
            >
        <span className="ml-2">
          {formik.isSubmitting ? (
              <Loader size={30} className="animate-spin" />
          ) : requestStatus == "201" ? (
              <Check size={35} className="animate-pulse" />
          ) : (
              <div className="flex items-center space-x-2">
                  <Share color="#FFF" />
                  <span>Partager</span>
              </div>
          )}
        </span>
            </button>
            <div
                className={`text-lg ${requestStatus == "201" ? "text-[#9EBE43]" : "text-red-500"} mt-4 font-bold`}
            >
                {response}
            </div>
        </form>
    );
};

export default TicketShareForm;
